import { cfetch } from '@confluence/network';

import { AbortErrors } from '../config/abortErrors.tsx';

export const REQUEST_ABORTED = 'REQUEST_ABORTED';

export const checkForAbortErrorMsg = (error: Error): boolean => {
	return !!AbortErrors[error.message?.trim()];
};

export const cfetchWithAbort = (url: any, options: any = {}): Promise<Response> => {
	return cfetch(url, options).catch((error) => {
		if (options.signal?.aborted || checkForAbortErrorMsg(error)) {
			throw REQUEST_ABORTED;
		}

		throw error;
	});
};
